var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"survey-completed h-100 text-center d-flex align-center justify-center",staticStyle:{"font-size":"50px","font-weight":"bold"}},[(_vm.alreadyCompleted)?[_vm._v(" "+_vm._s(_vm.$t("survey.alreadyCompletedMessage"))+" ")]:[_vm._v(" "+_vm._s(_vm.$t("survey.completedMessage"))+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }